// Honda PGM-FI self-diagnosis (MIL) trouble codes -> descriptions.
// Sourced from the Honda Flash Tools DTC reference (method_111).
const HONDA_DTC = {
  1: 'MAP sensor (Manifold Absolute Pressure)',
  2: 'MAP sensor performance',
  7: 'Engine Coolant Temperature sensor (ECT/EOT)',
  8: 'Throttle Position sensor (TP) / poor performance',
  9: 'Intake Air Temperature (IAT) sensor signal',
  10: 'MAP sensor',
  11: 'Vehicle speed sensor (VSS) circuit damaged',
  12: 'Injector control circuit No.1',
  14: 'Injector control circuit No.3',
  15: 'Injector control circuit No.4',
  16: 'Secondary injector control circuit No.1',
  17: 'Secondary injector control circuit No.2',
  18: 'Camshaft (CMP) signal lost',
  19: 'Ignition pulse generator (CKP) signal lost',
  20: 'EEPROM cache error in ECM',
  21: 'Oxygen (O2) sensor signal circuit error',
  22: '2nd oxygen sensor signal circuit error',
  23: 'Oxygen (O2) sensor heater control circuit error',
  24: 'Oxygen sensor heater control circuit error No.2',
  29: 'Idle Air Control Valve (IACV)',
  33: 'ECM EEPROM cache error',
  54: 'Bank angle (tilt) sensor signal',
  56: 'Coolant temperature sensor signal',
  71: 'TP sensor No.1 voltage out of range',
  72: 'TP sensor No.2 voltage out of range',
  73: 'TP No.1/No.2 synchronization error',
  86: 'Serial communication (MIL / CAN)',
  87: 'FISV fast idle solenoid valve error',
  88: 'EVAP fuel evaporator valve circuit error',
  89: 'PAIR/AISV secondary air injection circuit error',
  90: 'Primary ignition coil control circuit failure',
  91: 'Primary ignition coil control circuit failure',
};

export function dtcName(code) {
  return HONDA_DTC[code] || 'The error code is not in the database yet. Please wait for an update!';
}
